import { useQuery } from 'react-query'
import compress from 'graphql-query-compress'
import { axiosClient } from 'lib/core/services/magento/client'

interface Response {
  data: {
    data: {
      categoryList: Array<{
        cms_block: null | {
          content: string
          identifier: string
          title: string
        }
      }>
    }
  }
}

const query = (id: string | number) => `
  {
    categoryList (
      filters: {
        ids: { eq: "${id}" }
      }
    )
    {
      cms_block {
        content
        identifier
        title
      }
    }
  }
`

export const useCategoryCmsBlock = (categoryId: string | number) => {
  const { data } = useQuery(['useCategoryCmsBlock', categoryId], async () => {
    return axiosClient(compress(query(categoryId)))
  })

  const res = data as Response | undefined
  const cmsBlock = res?.data.data.categoryList?.[0]?.cms_block ?? undefined

  return {
    cmsBlock
  }
}
